import React, { useState, useEffect, lazy } from 'react';
import {
    Row

} from "reactstrap";
import { Colxx } from '../../components/common/CustomBootstrap';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { NavLink, withRouter } from 'react-router-dom';
import { useHistory } from "react-router-dom";
import { Switch, Route, Redirect } from "react-router-dom";
import { useRouteMatch } from "react-router-dom";
import {
    FaUserAlt,
    FaFile,
    FaChartBar,
    FaBriefcase,
    FaGraduationCap,
    FaChartArea,
    FaListUl
} from "react-icons/fa";

const BasicInfo = lazy(() => import('../app/dashboard/myprofile/basicinfo/basicinfo'));
const Resume = lazy(() => import('../app/dashboard/myprofile/resume/resume'));
const JOBExperiences = lazy(() => import('../app/dashboard/myprofile/experience/jobexperiences'));
const CandidateSkills = lazy(() => import('../app/dashboard/myprofile/candskills/candidateskills'));
const CandidateEducation = lazy(() => import('../app/dashboard/myprofile/education/candidateeducation'));
const CareerHighlights = lazy(() => import('../app/dashboard/myprofile/careerhighlights/careerhighlights'));
const JobPreferences = lazy(() => import('../app/dashboard/myprofile/jobpreference/jobpreferences'));
// const AddEducation = lazy(() => import('../profile/education/addeducation'));
const CandidateAddEducation = lazy(() => import('../app/dashboard/myprofile/education/candidateaddeducation'));
const CandidateAddExperience = lazy(() => import('../app/dashboard/myprofile/experience/candidateaddexperience'));
const PeerRating = lazy(() => import('./peerrating'));
const AskPeerRating = lazy(() => import('./peerrating/AskPeerRating'));
const InviteToRatePeers = lazy(() => import('./peerrating/invitetoratepeers'));
const AppliedJobs = lazy(() => import('./appliedjobs'));
const AppliedJobDetailsScreen =  lazy(() => import('./appliedjobdetails'));

const CandidateInfo = (props) => {
    const history = useHistory();
    return (
        <>
            <Row xxs={12}>
                <Colxx sm={3} className="sidebar-candidateinfo">
                    <div className='barmenu_col_menu'>
                        <div className="barmenu_checklist" >

                            <div className='barmenu_row mt-4 barmenu_row_active'>
                                <NavLink className='barmenu_row_title'
                                    to={'/basicinfo'}>
                                    <div className="row">
                                        <a
                                            href="#Foo" data-scroll="smooth"
                                        >
                                            <FaUserAlt className="mr-2" />
                                            Basic Info
                                        </a>
                                    </div>
                                </NavLink>
                            </div>


                            <div className='barmenu_row mt-4 barmenu_row_active'>
                                <NavLink className='barmenu_row_title'
                                    to={'/resume'}>

                                    <div className="row">
                                        <a
                                            href="#Foo" data-scroll="smooth"
                                        >
                                            <FaFile className="mr-2" />
                                            Resume
                                        </a>
                                    </div>
                                </NavLink>
                            </div>

                            <div className='barmenu_row mt-4 barmenu_row_active'>
                                <NavLink className='barmenu_row_title'
                                    to={'/candidateskills'}>

                                    <div className="row">
                                        <a
                                            href="#Foo" data-scroll="smooth"
                                        >
                                            <FaChartBar className="mr-2" />
                                            Skills
                                        </a>
                                    </div>

                                </NavLink>
                            </div>

                            <div className='barmenu_row mt-4 barmenu_row_active'>
                                <NavLink className='barmenu_row_title'
                                    to={'/jobexperiences'}>

                                    <div className="row">
                                        <a
                                            href="#Foo" data-scroll="smooth"
                                        >
                                            <FaBriefcase className="mr-2" />
                                            Job Experiences
                                        </a>
                                    </div>
                                </NavLink>
                            </div>

                            <div className='barmenu_row mt-4 barmenu_row_active'>
                                <NavLink className='barmenu_row_title'
                                    to={'/candidateeducation'}>

                                    <div className="row">
                                        <a
                                            href="#Foo" data-scroll="smooth"
                                        >
                                            <FaGraduationCap className="mr-2" />
                                            Education
                                        </a>
                                    </div>
                                </NavLink>
                            </div>

                            <div className='barmenu_row mt-4 barmenu_row_active'>
                                <NavLink className='barmenu_row_title'
                                    to={'/careerhighlights'}>

                                    <div className="row">
                                        <a
                                            href="#Foo" data-scroll="smooth"
                                        >
                                            <FaChartArea className="mr-2" />
                                            Career Highlights
                                        </a>
                                    </div>

                                </NavLink>
                            </div>

                            <div className='barmenu_row mt-4 barmenu_row_active'>
                                <NavLink className='barmenu_row_title'
                                    to={'/jobpreferences'}>

                                    <div className="row">
                                        <a
                                            href="#Foo" data-scroll="smooth"
                                        >
                                            <FaListUl className="mr-2" />
                                            Job Preferences
                                        </a>
                                    </div>
                                </NavLink>
                            </div>

                            <div className='barmenu_row mt-4 barmenu_row_active'>
                                <NavLink className='barmenu_row_title'
                                    to={'/askpeerrating'}>

                                    <div className="row">
                                        <a
                                            href="#Foo" data-scroll="smooth"
                                        >
                                            <FaListUl className="mr-2" />
                                            Peer Rating
                                        </a>
                                    </div>
                                </NavLink>
                            </div>

                            <div className='barmenu_row mt-4 barmenu_row_active'>
                                <NavLink className='barmenu_row_title'
                                    to={'/appliedjobs'}>

                                    <div className="row">
                                        <a
                                            href="#Foo" data-scroll="smooth"
                                        >
                                            <FaListUl className="mr-2" />
                                            Applied Jobs
                                        </a>
                                    </div>
                                </NavLink>
                            </div>


                        </div>
                    </div>

                </Colxx>
                <Colxx sm={9}>
                    <div
                        options={{ suppressScrollX: true, wheelPropagation: false }}
                    >
                        <div>
                            <Route exact path="/basicinfo" component={BasicInfo} />
                            <Route path="/resume" component={Resume} />
                            <Route path="/jobexperiences" component={JOBExperiences} />
                            <Route path="/candidateskills" component={CandidateSkills} />
                            <Route path="/candidateeducation" component={CandidateEducation} />
                            <Route path="/careerhighlights" component={CareerHighlights} />
                            <Route path="/jobpreferences" component={JobPreferences} />
                            {/* <Route path="/addeducation" component={AddEducation} /> */}
                            <Route path="/addcandidateeducation" component={CandidateAddEducation} />
                            <Route path="/candidateaddexperience" component={CandidateAddExperience} />
                            <Route path="/peerrating" component={PeerRating} />
                            <Route path="/askpeerrating" component={AskPeerRating} />
                            <Route path="/invitetoratepeers" component={InviteToRatePeers} />
                            <Route path="/appliedjobdetails" component={AppliedJobDetailsScreen} />
                            <Route path="/appliedjobs" component={AppliedJobs} />
                            <Redirect to="/basicinfo" />
                        </div>
                    </div>
                </Colxx>
            </Row>
        </>
    )
}

export default withRouter(CandidateInfo);
